import { useEffect, useState, useCallback } from "react";
import { requiresAds } from "@vninvestcharts/engine-core";
export { requiresAds };
export function checkTampering(badge) {
    if (!badge)
        return true;
    if (!badge.isConnected)
        return true;
    const text = badge.textContent?.trim().toLowerCase() || "";
    if (!text.includes("vninvest"))
        return true;
    const iconEl = badge.querySelector("span, img, svg");
    if (!iconEl)
        return true;
    if (!iconEl.isConnected)
        return true;
    const style = window.getComputedStyle(badge);
    if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0")
        return true;
    if (badge.offsetWidth === 0 && badge.offsetHeight === 0)
        return true;
    return false;
}
export function useTrademarkCompliance({ patTier, enforcementEnabled = false, badgeRef, }) {
    const [isDegraded, setIsDegraded] = useState(false);
    const shouldShowTrademark = requiresAds(patTier) || patTier === "none";
    const checkTamper = useCallback(() => {
        if (!shouldShowTrademark)
            return;
        if (checkTampering(badgeRef.current)) {
            setIsDegraded(true);
        }
    }, [shouldShowTrademark, badgeRef]);
    useEffect(() => {
        if (!shouldShowTrademark || !enforcementEnabled)
            return;
        const initialCheck = setTimeout(() => checkTamper(), 3000);
        const interval = setInterval(checkTamper, 5000);
        return () => {
            clearTimeout(initialCheck);
            clearInterval(interval);
        };
    }, [checkTamper, shouldShowTrademark, enforcementEnabled]);
    const onRestore = useCallback(() => {
        setIsDegraded(false);
        setTimeout(checkTamper, 100);
    }, [checkTamper]);
    return {
        shouldShow: shouldShowTrademark,
        isDegraded,
        onRestore,
    };
}
